import React, { useState, Component } from 'react';
import { withRouter, Redirect } from 'react-router-dom';
import { APP_VERSION } from '../constants';
import { clearLocalStorage } from '@/utils/storage';

function LoggedUserRed(ComposedComponent, extraInfo) {
  class LoginAccessCrtl extends Component {
    constructor(props) {
      super(props);
      this.state = {
        userDetail: localStorage.getItem('okta-token-storage')
          ? JSON.parse(localStorage.getItem('okta-token-storage'))
          : {},
      };
    }

    componentDidMount() {
      const { userDetail } = this.state;
      if (userDetail.idToken && userDetail.accessToken) {
        this.props.history.push('/');
      } else {
        clearLocalStorage();
      }
      // let appVersion = localStorage.getItem('app_ver')
      // if(appVersion){
      //   if(appVersion < APP_VERSION){
      //     localStorage.clear()
      //     localStorage.setItem('app_ver', APP_VERSION)
      //     setTimeout(() => {
      //       this.props.history.push('/login')
      //     }, 1000)
      //   }
      // }
      // else{
      //   localStorage.clear()
      //   localStorage.setItem('app_ver', APP_VERSION)
      // }
    }

    render() {
      const { userDetail } = this.state;
      if (!(userDetail.idToken && userDetail.accessToken)) {
        clearLocalStorage();
        return <ComposedComponent />;
      } else {
        return <Redirect to="/" />;
      }
    }
  }
  return withRouter(LoginAccessCrtl);
}
export default LoggedUserRed;
